export const SUPPORT_EMAIL = 'service@sanactivo.com';
